import React from 'react';
import UnifiedColumnSortFilter from '../filters/UnifiedColumnSortFilter';
import { ColumnConfig } from '../../utils/customerSentimentutils';

interface FilterMenuProps {
  columnId: string;
  columnLabel: string;
  column: ColumnConfig;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  uniqueValues: string[];
  searchTerm: string;
  selectedValues: string[];
  /** Commits checkbox selections + in-menu search to parent (e.g. on Apply). */
  onCommitTextFilter: (values: string[], inMenuSearch: string) => void;
  onClearTextFilter: () => void;
  dateFilter: { startDate: Date | null; endDate: Date | null };
  onDateFilterApply: (startDate: Date | null, endDate: Date | null) => void;
  onClearDateFilter: () => void;
}

export const FilterMenu: React.FC<FilterMenuProps> = ({
  columnId,
  columnLabel,
  column,
  anchorEl,
  onClose,
  uniqueValues,
  searchTerm,
  selectedValues,
  onCommitTextFilter,
  onClearTextFilter,
  dateFilter,
  onDateFilterApply,
  onClearDateFilter,
}) => {
  return column.isDate ? (
    <UnifiedColumnSortFilter
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      columnKey={columnId}
      title={columnLabel}
      isSortable={false}
      onSort={() => {}}
      forceShowFilterTab
      isDateFilter
      dateFilter={dateFilter}
      onDateFilterApply={(startDate, endDate) => {
        onDateFilterApply(startDate, endDate);
      }}
      primaryFooterLabel="Apply"
      secondaryFooterLabel="Cancel"
      secondaryFooterVariant="outlined"
      showSelectionCountInApply={false}
      showHeaderClearIcon={
        Boolean(dateFilter.startDate || dateFilter.endDate)
      }
      onHeaderClearFilter={() => {
        onClearDateFilter();
        onClose();
      }}
    />
  ) : (
    <UnifiedColumnSortFilter
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      columnKey={columnId}
      title={columnLabel}
      isSortable={false}
      onSort={() => {}}
      forceShowFilterTab
      enableSearch
      filterOptions={uniqueValues}
      selectedFilterValues={selectedValues}
      initialFilterSearchTerm={searchTerm}
      onFilterApply={(values, meta) => {
        onCommitTextFilter(values, meta?.searchTerm ?? '');
      }}
      showHeaderClearIcon={selectedValues.length > 0 || Boolean(searchTerm.trim())}
      onHeaderClearFilter={() => {
        onClearTextFilter();
        onClose();
      }}
      primaryFooterLabel="Apply"
      secondaryFooterLabel="Cancel"
      secondaryFooterVariant="outlined"
      showSelectionCountInApply={false}
    />
  );
};
